module.exports = __webpack_public_path__ + "static/img/3_2_6_1.ac8c3dd4.jpg";